import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsights = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 50.91024 50.8988",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "insights" }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4.01923,
			y: 10.21274,
			width: 14.29059,
			height: 39.43606,
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.30982,
			y: 22.90996,
			width: 14.29059,
			height: 26.73884,
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.60041,
			y: 1.25,
			width: 14.29059,
			height: 48.3988,
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})
	] })]
});
export default SvgInsights;
